export enum SimpleTableElement {
  Header = 'header',
  Data = 'data',
}
